import { CallApiOptions } from './api';

export const loginCallOptions = (
  email: string,
  password: string
): CallApiOptions => ({
  method: 'POST',
  endpoint: `v2/auth/login`,
  body: JSON.stringify({
    email,
    password,
  }),
});



// WEBPACK FOOTER //
// ./src/services/auth.services.ts